import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import {Table} from "react-bootstrap";
import { DockEstimatesContext } from "../../DockEstimatesContext";
import { DockHighlightContext } from "../../DockHighlightContext";
import DeliveryRowDnd from "../Deliveries/DeliveryRowDnd";
import {DeliveryRow} from "../Deliveries/DeliveryRow";
import DefaultDropZoneBuilder from "../common-comps/DefaultDropZone";

import "../../css/Dock.css";
import moment from "moment";
import {OtherActivityButton} from "./Dock/OtherActivityButton";
import {FinishDockButton} from "./Dock/FinishDockButton";
import DockTitleLinked from "./Dock/DockTitleLinked";
import { EXTERNAL_DOCK_TYPES } from '../../utils/dock_n_driver';


// Paris intramuros = arrondissements 75001–75020 (+ 75116) : territoire scooter.
function isParisIntramuros(pc) {
  if (!pc) { return false; }
  const n = parseInt(pc, 10);
  return (n >= 75001 && n <= 75020) || pc === "75116";
}

// const ANSWER_TYPE_ID__REFUSED = 0
// const ANSWER_TYPE_ID__ACCEPTED = 1
const ANSWER_TYPE_ID__TIMEOUT = 2

const DefaultDropZone = DefaultDropZoneBuilder.build("TASK/DELIVERY");

const Dock = ({dock, transit_areas, docks, docks_extract, onDropTask, onDropDefault, handlerDockDnd, connectDragPreview, connectDropTarget, show, className}) => {

  // Métriques estimées par notre lib pour ce dock (affichées si le bouton « coûts estimés » est actif).
  const dockEstimates = useContext(DockEstimatesContext);
  const estimate = dockEstimates && dockEstimates[dock.id];

  // Surlignage des tournées 100% Paris intramuros (scooter) pour les distinguer des autres véhicules.
  const highlightParis = useContext(DockHighlightContext);
  const isParisDock = highlightParis
    && dock.tasks.length > 0
    && dock.tasks.every((t) => t.address && isParisIntramuros(t.address.postal_code));

  let colspan = 8;
  const name = dock.name;
  const tasks = dock.tasks;
  show.externalCall = !EXTERNAL_DOCK_TYPES.includes(dock.dock_type) &&
    dock.tasks.length === 1;

  let listTasks = null;
  let now = moment(new Date());
  let dockAge = now.diff(moment(dock.created_at), 'days');
  const driverIsReturning = dock.tasks.length > 0 && dock.tasks.slice(-1)[0].linked_order && ["received", "undeliveredclient"].includes(dock.tasks.slice(-1)[0].linked_order.status) || false;
  const driverIsBackClass = dock.driver && dock.driver.is_back ? " driver-is-back" : "driver-is-not-back";
  let dockClassNames = "Dock col-12 col-sm-6 col-md-6 col-huge-2 " + dock.dock_type.toLowerCase() + " " + dock.current_status + " " + driverIsBackClass + (isParisDock ? " dock-paris-highlight" : "");
  if (className) {
    dockClassNames += className;
  }
  if (dock.locked_at) {
    dockClassNames += " locked";
  }

  if (dock.dock_type === 'STUART') {
    dockClassNames += " stuart";
  }

  if (dock.dock_type === 'UBER') {
    dockClassNames += " uber";
  }

  if (
    dock.external_job && (
      [
        'voided',
        'expired',
        'canceled',
        'returned',
      ].includes(dock.external_job.status)
      || (
        ['in_progress', 'finished'].includes(dock.external_job.status)
        && dock.external_job.cancel_reason
      )
    )
  ) {
    dockClassNames += " canceled-external-job";
  }

  if (dock.loaded_at && !dock.locked_at) {
    dockClassNames += " loaded";
  }

  if(dock.cross_docking_target_center !== null){
    dockClassNames += " cross_dock";
  }

  if (tasks.length === 0) {

    let resetCase = dock.dock_type !== 'DRIVER_HARD' && dock.external_job && ['voided', 'expired'].includes(dock.external_job.status);
    resetCase = resetCase || (dock.dock_type !== 'DRIVER_HARD' && dock.locked_at);

    if(onDropDefault){
      listTasks = (
        <DefaultDropZone dock={dock} docks={docks} name={name} onDropDefault={onDropDefault} colSpan={colspan}>
          {dock.dock_type === 'DRIVER_HARD' ? <OtherActivityButton driver={dock.driver} /> : null}
          {resetCase ?
            <FinishDockButton dock={dock} /> : null}
          {'\u00A0'}
        </DefaultDropZone>
      );
    }
    else{
      listTasks = (
        <tr>
          <td colSpan={colspan} style={{textAlign: "center"}}>
            {dock.dock_type === 'DRIVER_HARD' ? <OtherActivityButton driver={dock.driver} /> : null}
            {resetCase ? <FinishDockButton dock={dock} /> : null}
            {'\u00A0'}
          </td>
        </tr>
      );
    }
  } else {
    listTasks = tasks.map((task, idx) => {
      // Build a composite key to avoid duplicate key warnings when task ids may collide
      const compositeKey = `${task.id}-${task.dock_rank || task.dock_rank_target || idx}`;
      if (!onDropTask || dock.locked_at || dock.uberdirect_batch) {
        return (
          <DeliveryRow key={compositeKey}
            task={task}
            dock={dock}
            docks_extract={docks_extract}
            show={show}
            inCrossdock={dock.cross_docking_target_center !== null}
            addressFormatting={'compact'}
          />
        );
      } else {
        return (
          <DeliveryRowDnd key={compositeKey}
            transit_areas={transit_areas}
            task={task}
            docks={docks}
            docks_extract={docks_extract}
            onDropTask={
              (...args) => {
                if (dockAge >= 15) {
                  alert(`ce dock est trop vieux: ${dockAge} jours`);
                } else if (driverIsReturning) {
                  alert('le livreur est en retour, impossible de modifier ce dock');
                } else {
                  onDropTask(...args);
                }
              }
            }
            dock={dock}
            show={show}
            inCrossdock={dock.cross_docking_target_center !== null}
            addressFormatting={'compact'}
          />
        );
      }
    });
  }

  let handlerDockDndElement = null;
  let headerColspan = colspan;
  if (handlerDockDnd && !dock.locked_at) {
    if (
      dock.tasks.length > 0
      && !dock.isLock
    ) {
      handlerDockDndElement = handlerDockDnd(<th className="draggable" title={`dock_id: ${dock.id}`}></th>);
    } else {
      handlerDockDndElement = (<th className="draggable locked" title={`dock_id: ${dock.id}`}></th>);
    }
    headerColspan--;
  }

  let driverGainReal = (
    dock.driver_gain_real === null
    ? null
    : <span> pour {dock.driver_gain_real.toFixed(2)} €</span>
  );

  const getDockClassName = () => {
    if (dock.accepted_by_driver == null || dock.accepted_by_driver === false) {
      return "Dock-not-accepted";
    }

    if (dock.time_take_bags == null) {
      return "Dock-gone";
    }

    // on calcul le temps restant pour prendre les sacs si la tournée est acceptée
    let delta = now.diff(moment(dock.locked_at), 'seconds');
    let remaining_take_bags_time = dock.time_take_bags - delta;

    if (remaining_take_bags_time <= 0) {
      return "Delay-time-take-bags";
    }
    if (remaining_take_bags_time < 180) {
      return "Limit-time-take-bags";
    }
    return "Ontime-time-take-bags";
  };

  let estimatedDeparture = (
    <span style={{ float: 'right' }}>départ prévu à {moment(dock.locked_at).add(dock.time_take_bags, 'seconds').format("HH:mm", 'fr').replace(':', 'h')}</span>
  );

  function formatDuration(fromDate) {
    const now = moment();
    const duration = moment.duration(now.diff(moment(fromDate)));

    const hours = duration.hours();
    const minutes = duration.minutes();

    if (hours === 0) {
      return `${minutes} min`;
    }
    return `${hours}h${minutes > 0 ? minutes + "min" : ""}`;
  }

  const dockElement =  (
    <div className={dockClassNames}>
      <Table bordered size="sm" hover striped>
        <thead>
          <tr>
            {handlerDockDndElement}
            <th colSpan={headerColspan} >
              <DockTitleLinked dock={dock} />
            </th>
          </tr>

          {estimate ?
            <tr className="subheader">
              <td colSpan={colspan} className="Dock-estimate">
                {estimate.unroutable
                  ? <span>lib estim. : <b>non calculable</b> (tronçon non routable)</span>
                  : <span>
                      lib estim. : <b>{estimate.cost_eur} €</b> · {estimate.time_min} min ·
                      retard <b className={estimate.delay_min > 0 ? "Dock-estimate-late" : ""}>{estimate.delay_min}m</b> ·
                      avance <b>{estimate.wait_min}m</b>
                    </span>
                }
              </td>
            </tr> : null
          }

          {dock.return_time ?
            <tr className="subheader">
              <td colSpan={colspan} className={getDockClassName()}>
                {dock.driver && dock.driver.is_paid_by_race && dock.accepted_by_driver === null ?
                  <b style={{"color": "orange"}}><i className="fa-solid fa-circle-minus"></i> Tournée en cours d'acceptation {driverGainReal}</b>
                  : dock.driver && dock.driver.is_paid_by_race && dock.accepted_by_driver === false ?
                    (
                      dock.driver_answer === ANSWER_TYPE_ID__TIMEOUT
                        ? <b style={{"color": "red"}}><i className="fa-solid fa-circle-minus"></i> Le livreur n'a pas répondu avant la fin du délai {driverGainReal}.</b>
                        : (
                          <b style={{"color": "red"}}>
                            <i className="fa-solid fa-circle-minus"></i>
                            Le livreur a refusé la tournée {driverGainReal}.
                            {dock.driver && dock.driver.daily_refusals_limit_exceeded && (
                              <strong style={{marginLeft: '3px'}}>Limite de refus dépassée</strong>
                            )}
                          </b>
                        )
                    )
                    : <span>
                      { dock.gone_at ? `Départ ${moment(dock.gone_at).format("HH:mm", 'fr').replace(':', 'h')} (${formatDuration(dock.gone_at)})` : `En liv depuis ${moment(dock.locked_at).format("HH:mm", 'fr').replace(':', 'h')} (${formatDuration(dock.locked_at)})` },
                      retour prévu à <b>{dock.return_time.replace(':', 'h')}</b>
                      {driverGainReal}
                      {estimatedDeparture}
                    </span>
                }
              </td>
            </tr> : null
          }
        </thead>
        <tbody>{listTasks}</tbody>
      </Table>
    </div>
  );

  return (handlerDockDnd && !dock.locked_at ? connectDragPreview(connectDropTarget(dockElement)) : dockElement);
};


Dock.propTypes = {
  dock: PropTypes.object.isRequired,
  transit_areas: PropTypes.object.isRequired,
  docks_extract: PropTypes.object,
  docks: PropTypes.array.isRequired,
  onDropDefault: PropTypes.func,
  onDropTask: PropTypes.func,
  handlerDockDnd: PropTypes.func,
  connectDragPreview: PropTypes.func,
  connectDropTarget: PropTypes.func,
  show: PropTypes.object,
  classes: PropTypes.string
};

export default Dock;
